// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__14-6j","approved":"Status_approved__UkRrw","rejected":"Status_rejected__3rcJR","expired":"Status_expired__3n9gY","label":"Status_label__3LNj7"};